import React, { useEffect, useState, useContext } from "react";
import PropTypes from "prop-types";
import UserContext from "@/context/UserContext";

import DataGrid from "@/layouts/tables/DataGrid";
import DataGridTableToolbar from "@/utility/DataGridTableToolbar";
import Loading from "@/shared/Loading";
import { fetchAPI } from "@/utility/NetworkUtils";
import { formatEventDate } from "@/utility/DateUtils";
import { isJaguar } from "@/utility/UserUtils";
import { Link } from "@mui/material";
import EventCloneModal from "./modals/EventCloneModal"
import Cookies from "universal-cookie";
import CheckIcon from '@mui/icons-material/Check';
const EventsTable = (props) => {

  const [ loading, setLoading ] = useState(true);
  const [ events, setEvents ] = useState([]); 
  const { archived, renters, shipping_addresses, openEditModal = () => {}} = props;
  const { user } =  useContext(UserContext);
  useEffect(() => {
    fetchEvents();
  }, []);

  const fetchEvents = () => {
    setLoading(true)
    fetchAPI(`/webapi/events/table?archived=${archived}`, (json) => {
      if (!json.errors) {
        setLoading(false)
        setEvents(json.events)
      } else {
        console.log({
          errors: json.errors
        })
      }
    })
  }

  const getItems = () => {
    return events
  }

  const getColumns = () => {
    return [
      {field: "name", flex: 1, headerName: "Event Name", renderCell: (params) => {
        return (
          <Link className="font-bold color-[#0B7]" color="#0B7" href={`/events/${params.row.slug}`}>
            {params.value}
          </Link>
        )
      }},
      {field: "start_date", flex: 1, headerName: "Event Date", renderCell: (params)=>{
        return formatEventDate(params.row)
      }, valueGetter: (value) => {
        return new Date(value)
      }},
      {
        field: 'job_number',
        flex: 1,
        headerName: 'Job #',
        hidden: !isJaguar(user)
      },
      {
        field: 'total_item_count',
        maxWidth: 100,
        headerName: 'Reserved',
        headerAlign: 'center',
         renderCell: (params) => (<div className="text-center font-bold">{params.row.total_item_count}</div>),
      },
       {
        field: 'total_packed_count',
        maxWidth: 100,
        headerName: 'Packed',
        headerAlign: 'center',
        renderCell: (params) => (<div className="text-[#E60073] text-center font-bold">{params.row.total_packed_count}</div>),
      },
       {
        field: 'total_shipped_count',
        maxWidth: 100,
        headerName: 'Shipped',
        headerAlign: 'center',
        renderCell: (params) => (<div className="text-[#3070E7] text-center font-bold">{params.row.total_shipped_count}</div>),
      },
       {
        field: 'total_returned_count',
        maxWidth: 100,
        headerName: 'Finalized',
        headerAlign: 'center',
        renderCell: (params) => (<div className="text-[#0B7] text-center font-bold">
          {params.row.manifest_return_completed_at ? (
            <CheckIcon color={"green"} className="mt-[12px]"/>
          ):""}
        </div>),
      },
      {
        headerName: "Actions",
        field: "actions",
        type: "actions",
        flex: 1,
        minWidth: 200,
        maxWidth: 250,
        align: "right",
        getActions: renderActions
      },
    ].filter(x=>!x.hidden)
  }

  const deleteEvent = (event) => {
    const cookies = new Cookies();
    const token = cookies.get("X-CSRF-Token");
    if(confirm("Are you sure you want to delete this event? This cannot be undone.")){
      fetch(`/events/${event.slug}`, {
        method: 'DELETE',
        redirect: "manual",
        headers: {
          "X-CSRF-Token": token,
        }
      })
        .then(response => {
          return response.json();
        })
        .then(json => {
          if (json.error == null) {
            fetchEvents();
          } else {
            alert(json.error);
          }
        });
    }
  }

  const archiveEvent = (event) => {
    const cookies = new Cookies();
    const token = cookies.get("X-CSRF-Token");

    fetch(`/events/${event.slug}/archive`, {
      method: 'POST',
      redirect: "manual",
      body: JSON.stringify({archive: !event.archived_at}),
      headers: {
        "X-CSRF-Token": token,
        "Content-Type": 'application/json'
      }
    })
      .then(response => {
        return response.json();
      })
      .then(json => {
        if (json.error == null) {
          fetchEvents();
        } else {
          alert(json.error);
        }
      });
  }


  const renderActions = (params) => {
    let actions = [];
    if(isJaguar(user)) {
      actions.push(
        <Link component="button" onClick={()=>{openEditModal(params.row.id)}}>EDIT</Link>
      )

      actions.push(
        <EventCloneModal
          button={(
            <Link component="button" onClick={()=>{
            }}>Clone</Link>
          )}
          event={params.row}
          shipping_addresses={shipping_addresses||[]}
        />
      )


      actions.push(
        <Link component="button" onClick={()=>{deleteEvent(params.row)}}>Delete</Link>
      )



      actions.push(
         <Link component="button" onClick={()=>{archiveEvent(params.row)}}>{params.row.archived_at ? "Unarchive" : "Archive"}</Link>
      )
    }

    return actions
  }
  if(loading) {
    return <Loading />
  }
  return (
    <DataGrid
      tableName={`events-2-${archived ? "archived" : "active"}`}
      unstable_headerFilters
      rows={getItems()}
      columns={getColumns()}
      slots={{
        toolbar: DataGridTableToolbar
      }}
      sortField="start_date"
      sortDirection={archived ? "desc" : "asc"}
      

      pageSizeOptions={[5, 10, 20, 50, 100]}
    />
  )
}

export default EventsTable